module.exports = __webpack_public_path__ + "static/media/us.d72324f5.svg";